// extracted by mini-css-extract-plugin
export default {"online":"online_online__c2sSC","online__back":"online_online__back__TOTO4"};